<template>
  <div v-if="group.name !== undefined" class="simcard-group__config">
    <div class="card_add center-block col-md-9">
      <fg-input
        v-model="group.name"
        type="text"
        placeholder="name group"
        @keydown.enter="save_config"
      />

    </div>
    <span class="col-md-3">
      <button
        type="submit"
        class="mdi mdi-archive btn btn-success "
        @click.prevent="save_config"
      >
        {{translate('config.save')}}
      </button>

    </span>
  </div>
</template>

<script>

export default {
  name: 'SimCardProfileConfig',
  components: {
  },
  props: ['group'],
  data () {
    return {config: {multi_instance: {}}}
  },
  watch: {
  },
  methods: {
    save_config () {
      this.$http.v1.updateSimcardGroup({...this.group},(response) => {
        if (response.data.status === 'OK') {
          this.global_notify('info', this.translate('simcard_devices_groups.update'))
          this.$store.dispatch('groupSimcardDevicesUpdate')
        }else{
          this.global_notify('danger', this.translate('simcard_devices_groups.error_update'))
        }
      })
    },
  }
}
</script>

<style lang='scss' scoped>
  .simcard-group{
    &__config{
      display: flex;
      flex-direction: row;
      overflow: hidden;
      height: 100%;
    }
  }
</style>
